import type { EffectiveAreaResult, EffectiveAreasResponse } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'

export type { EffectiveAreaResult, EffectiveAreasResponse }

export const getEffectiveAreas = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<EffectiveAreasResponse> => {
  const response = await apiClient.get<EffectiveAreasResponse>(
    endpoints.v2.samplingAreas.effectiveAreas(farmId),
    { signal },
  )
  // This v2 route answers the result object directly (no `payload` envelope), so the
  // unwrap* helpers would reject a perfectly valid response as a contract break.
  return response.data
}
